import { render, staticRenderFns } from "./FixedColumnWrap.vue?vue&type=template&id=ccf1f462&"
import script from "./FixedColumnWrap.vue?vue&type=script&lang=js&"
export * from "./FixedColumnWrap.vue?vue&type=script&lang=js&"
import style0 from "./FixedColumnWrap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports